import { SkillTreeView } from '@/components/game/SkillTree';

export function SkillsPage() {
  return <SkillTreeView />;
}
